import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useSession } from '../../lib/store/session.js';
import { LoadingScreen } from '../Status/LoadingScreen.js';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useSession();
  const location = useLocation();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}
